export default "__VITE_ASSET__TrjfND36__"